module.exports = __webpack_public_path__ + "img/logo.d6a5567b.png";